export const myConfig = {
  apiUrl: 'https://bnapi.rootth.com/api',
  // apiUrl: 'http://localhost:3300/api',
};
